import http from "../http";
import Service from "../../Service";

export default class StoreQrCodeService extends Service {
    pdf(storeIds) {
        return http.get("v2/clients/stores/checkin-qrcode/pdf", {
            headers: this.getHeaders(),
            params: { store_id: storeIds && storeIds.length ? storeIds : undefined },
            responseType: "blob",
        });
    }
}
